import { Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery } from '@mui/material'
import WhiteButton from '../../components/WhiteButton'
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import styles from './styles.module.css';
import { keyframes } from "@emotion/react";
import { Fragment } from 'react';

const ModalTimeLine = ({ open, onClose, timeline }) => {
    const minDesktop = useMediaQuery("(max-width: 550px)");
    const pulse = keyframes`
        0% {
        transform: scale(1);
        }
        50% {
        transform: scale(1.2);
        }
        100% {
        transform: scale(1);
        }
        `;

    const handleOrganiza = (item) => {
        let icone = null
        let label = null
        switch (item.status) {
            case 'CRIADO': {
                icone = <CheckCircleOutlineIcon sx={{ fontSize: '4rem', color: '#02d05f' }} />
                label = `Criado por ${item.usuario}`
            } break;
            case 'APROVADO': {
                icone = <CheckCircleOutlineIcon sx={{ fontSize: '4rem', color: '#02d05f' }} />
                label = `Aprovado por ${item.usuario}`
            } break;
            case 'PENDENTE': {
                icone = <ErrorOutlineIcon sx={{ fontSize: '4rem', color: '#FFAE00', animation: `${pulse} 1.5s infinite ease-in-out` }} />
                label = `${item.usuario}`
            } break;
            case 'REPROVADO': {
                icone = <HighlightOffIcon sx={{ fontSize: '4rem', color: '#FF0004B2' }} />
                label = `${item.usuario} reprovou`
            } break;

            default: {
                icone = item.tipo === 'USUARIO' ? <PersonIcon sx={{ fontSize: '3.5rem', color: '#2196f36b' }} /> : <GroupIcon sx={{ fontSize: '4rem', color: '#2196f36b' }} />
                label = <p style={{opacity: '0.6'}}>{item.usuario}</p>
            }
                break;
        }
        const data = item.dtManipulado ? (new Date(item.dtManipulado).toLocaleString()).replace(',', '') : null
        return { icone, label, data }
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth='md'
        >
            <DialogTitle>
                Timeline
            </DialogTitle>
            <DialogContent>
                <div className={styles.tlContainer}>
                    {timeline?.map((item, index) => {
                        const dados = handleOrganiza(item)
                        return (
                            <Fragment key={index}>
                                <div className={styles.tlItem}>
                                    <div className={styles.tlCircle}>
                                        {dados.icone}
                                    </div>
                                    {dados.label && <span className={styles.tlLabel}>{dados.label}</span>}
                                    {dados.data && <span className={styles.tlData}>{dados.data}</span>}
                                </div>
                                {index !== timeline.length - 1 && (minDesktop ? <ArrowDropDownIcon sx={{fontSize: '2rem'}}/> : <PlayArrowIcon />)}
                            </Fragment>
                        )
                    })}

                </div>
            </DialogContent>
            <DialogActions>
                <WhiteButton
                    textValue='Fechar'
                    contentIcon={<CloseIcon />}
                    clickFunction={onClose}
                />
            </DialogActions>
        </Dialog>
    )
}

export default ModalTimeLine